import React from 'react';
import s from './TotalGroup.scss';

export enum TotalGroupDataHook {
  TotalLineTitle = 'TotalGroup.TotalLineName',
  TotalLineValue = 'TotalGroup.TotalLineValue',
  GroupTitle = 'TotalGroup.GroupTitle',
}

export type TotalLineProps = {
  title: string;
  value: string;
  key: string;
  additionalAttributes?: Record<string, string>;
};

export const TotalGroup = ({dataHook, totals, title}: {dataHook: string; totals: TotalLineProps[]; title: string}) => {
  if (totals.length > 1) {
    return <MultipleTotals dataHook={dataHook} totals={totals} title={title} />;
  }
  return (
    <div data-hook={dataHook} className={s.title}>
      <TotalLine total={totals[0]} />
    </div>
  );
};

export const MultipleTotals = ({
  dataHook,
  title,
  totals,
}: {
  dataHook: string;
  title: string;
  totals: TotalLineProps[];
}) => {
  return (
    <div data-hook={dataHook} className={s.multipleTotalsRoot}>
      <div data-hook={TotalGroupDataHook.GroupTitle} className={s.title}>
        {title}
      </div>
      {totals.map((total) => (
        <TotalLine total={total} key={total.key} />
      ))}
    </div>
  );
};

export const TotalLine = ({total}: {total: TotalLineProps}) => {
  return (
    <dl className={s.totalLine}>
      <dt>
        <span data-hook={TotalGroupDataHook.TotalLineTitle}>{total.title}</span>
      </dt>
      <dd data-hook={TotalGroupDataHook.TotalLineValue} {...total.additionalAttributes}>
        {total.value}
      </dd>
    </dl>
  );
};
